module.exports = __webpack_public_path__ + "bg-IVMS.46e4381028fe482fe46e.png";


//////////////////
// WEBPACK FOOTER
// E:/Git_new/IVMS_PRO/web/src/assets/images/bg-IVMS.png
// module id = ../../../../../src/assets/images/bg-IVMS.png
// module chunks = styles